
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}




function AddEtapaOportunidad (){
    const { tienePermiso } = useAccesos();

    return (
        <>
        {/* <h2>{editEtnia ? 'Editar Etnia' : 'Agregar Nueva Etnia'}</h2> */}
        <h2>Etapa de Oportunidad</h2>
        <br />
        <form id="formEtnia" className="form-horizontal form-label-left" >
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionEtnia">
                    Descripción: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3">
                    <input
                        type="text"
                        id="descripcionEtnia"
                        required="required"
                        className="form-control"
                        value=""
                    />
                </div>
            
           
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="porcentajeEtapa">
                        % Asignado a la etapa: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="number"
                            id="porcentajeEtapa"
                            required="required"
                            className="form-control"
                            min="0"
                            max="100"
                            step="1"
                            placeholder="0 - 100"
                        />
                    </div>
            </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Etapa Oportunidad')}> Guardar
                        {/* {editEtnia ? 'Actualizar' : 'Guardar'} */}
                    </button>
                </div>
            </div>
        </form>
    </>
    )
}


export default AddEtapaOportunidad;